if (!customElements.get('ai-editor-overlay')) {
  class AiEditorOverlay extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector('.ai-editor-overlay__close');
      this.backdrop = this.querySelector('.ai-editor-overlay__backdrop');
      this.iframe = this.querySelector('.ai-editor-overlay__iframe');

      this.closeButton.addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
    }

    open(opener, customUrl) {
      this.openedBy = opener;
      if (customUrl) {
        this.iframe.setAttribute('src', customUrl);
      } else {
        const dataSrc = this.iframe.getAttribute('data-src');
        if (dataSrc && !this.iframe.getAttribute('src')) {
          this.iframe.setAttribute('src', dataSrc);
        }
      }
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      trapFocus(this, this.closeButton);
    }

    close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.openedBy);
      this.iframe.removeAttribute('src');
    }
  }

  customElements.define('ai-editor-overlay', AiEditorOverlay);
}

// Wire up all AI editor trigger buttons
document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('AiEditorOverlay');
  if (!overlay) return;

  document.querySelectorAll('[data-ai-editor-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      overlay.open(trigger);
    });
  });
});
